import React, {useEffect, useState} from 'react';

import {
    Alert,
    Button, Card, CardBody, CardReadMore, CardText, CardTitle,
    Col, Container, Dropdown,
    DropdownMenu,
    DropdownToggle, FormGroup,
    Icon,
    Input, Label,
    LinkList,
    LinkListItem, RegisterOptions,
    Row,
    Select,
    Toggle
} from "design-react-kit";
import {properties} from "../../../config/properties";
import {useNavigate} from "react-router-dom";
const styles = {
    formContainer: {
        padding: '2rem',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        border: '1px solid #ddd'
    },
    formTitle: {
        marginBottom: '1.5rem',
        color: '#333',

        paddingBottom: '0.5rem'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem' // Spazio tra i pulsanti
    }
};
const RicercaPersone = ({user}) => {


    const [isOpen, setIsOpen] = useState(false);
    const [ruoli, setRuoli] = useState([]);
    const [aree, setAree] = useState([]);
    const [ruolo, setRuolo] = useState('*');
    const [area, setArea] = useState('*');
    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [codiceFiscale, setCodiceFiscale] = useState('');
    const [resetCount, setResetCount] = useState(0);

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });


    const toggle = () => setIsOpen(!isOpen);

    const navigate = useNavigate();

    async function getRuoliList() {
        try {

            setAlert({ visible: false, type: '', message: '' });


            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/ruoli`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();
            return json;  // qui ritorni direttamente l'array ricevuto
        } catch (e) {
            return [];
        }
    }


    async function getAreeList() {
        try {

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/areeCompetenza`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();
            return json;  // qui ritorni direttamente l'array ricevuto
        } catch (e) {
            return [];
        }
    }


    useEffect(() => {
        async function fetchData() {
            const dataRuoli = await getRuoliList();
            const dataAree = await getAreeList();
            setRuoli(dataRuoli?.ruoli ?? []);
            setAree(dataAree?.areeCompetenza ?? [])
        }
        fetchData();
    }, []);

    const handleConferma = () => {
        const datiRicerca = {

            offset : 0,
            limit : 10,
            dati : {
                nome,
                cognome,
                codiceFiscale,
                ruolo,
                area
            }
        };

        navigate('/private/elencoPersone', { state: { ricerca: datiRicerca } });
    };

    return (

        <Container className="bg-white py-5 py-lg-6">
            <div>
                <Row className={"justify-content-center"}>

                    <Col md={8}>
                        <h2 className={"mb-5"}>Cerca Persona</h2>

                        {alert.visible && (
                            <Alert color={alert.type} isOpen={alert.visible}
                                   toggle={() => setAlert({...alert, visible: false})}>
                                {alert.message}
                            </Alert>
                        )}

                        <div style={styles.formContainer}>
                            <h3 style={styles.formTitle}>
                                Filtri di ricerca
                            </h3>

                            <Row>
                                <Input
                                    id="nome"
                                    label="Inserisci Nome"
                                    type="text"
                                    wrapperClassName="col"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                />
                            </Row>

                            <Row>

                                <Input
                                    id="cognome"
                                    label="Inserisci Cognome"
                                    type="text"
                                    wrapperClassName="col"
                                    value={cognome}
                                    onChange={(e) => setCognome(e.target.value)}
                                />

                            </Row>

                            <Row>

                                <Input
                                    id="codiceFiscale"
                                    label="Inserisci Codice Fiscale"
                                    type="text"
                                    wrapperClassName="col"
                                    value={codiceFiscale}
                                    onChange={(e) => setCodiceFiscale(e.target.value)}
                                />

                            </Row>

                            <Row className="mb-5">
                                <Col>
                                    <Select
                                        key={resetCount}
                                        id="ruolo"
                                        label="Ruolo"
                                        value={ruolo}
                                        //defaultValue="*"
                                        onChange={(e) => setRuolo(e)}
                                    >
                                        <option value="*">Qualsiasi</option>
                                        {ruoli.map((item, index) => (
                                            <option key={index} value={item.id}>
                                                {item.titolo}
                                            </option>
                                        ))}

                                    </Select>
                                </Col>
                            </Row>

                            <Row className="mb-5">
                                <Col>
                                    <Select
                                        key={resetCount}
                                        id="area"
                                        label="Area di competenza"
                                        value={area}
                                        //defaultValue="*"
                                        onChange={(e) => setArea(e)}
                                    >
                                        <option value="*">Qualsiasi</option>
                                        {aree.map((item, index) => (
                                            <option key={index} value={item.id}>
                                                {item.descrAreaCompetenza}
                                            </option>
                                        ))}

                                    </Select>
                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-end">
                                <Col sm="auto">
                                    <Button
                                        className="btn btn-outline-secondary"
                                        outline
                                        onClick={() => {
                                            setNome('');
                                            setCognome('');
                                            setCodiceFiscale('');
                                            setRuolo('*');
                                            setArea('*');
                                            setResetCount(prev => prev + 1);
                                        }}
                                    >
                                        Cancella
                                    </Button>
                                </Col>
                                <Col sm="auto">
                                    <Button
                                        className="btn btn-outline-primary"
                                        type="submit"
                                        onClick={handleConferma}
                                    >
                                        Conferma
                                    </Button>
                                </Col>
                            </Row>

                        </div>
                    </Col>

                </Row>


            </div>

        </Container>

    );
};

export default RicercaPersone;


